declare module '@mui/material/Chip' {
    interface ChipPropsVariantOverrides {
        status: true;
    }
}


export default function Chi(theme: any) {
    return {
        MuiChip: {
            variants: [
                {
                    props: { variant: "status" },
                    style: {
                        height: '26px',
                        padding: theme.spacing(0, 1.25, 0, 1.25),
                        flexDirection: 'row-reverse',
                        color: theme.palette.common.white,
                        '& .MuiChip-icon': {
                            marginLeft: 1,
                        },
                        '& .MuiChip-label': {
                            margin: 0,
                            padding: 0,
                        }
                    },
                },
            ],
        },

    };
}

// status: {
//     alignSelf: "center",
//     marginLeft: "12px",
//     height: "26px",
//     fontSize: "14px",
//     color: theme.palette.grey[0],
//     borderRadius: "1000px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//   },
